import React from 'react';
import Layout from '../components/layout/Layout';
import { Link } from "react-router-dom";
import CTASection from "../components/common/CTASection";
import hero from "../assets/2.jpg";
import service1 from "../assets/service1.jpg";
import service2 from "../assets/service2.png";
import service3 from "../assets/service3.png";
import serviec4 from "../assets/service4.png";
import serviec5 from "../assets/service5.jpg";

const ServicesPage = () => {
  return (
    <Layout>
      {/* ===== HERO SECTION ===== */}
      <section 
        className="relative py-16 sm:py-20 bg-fixed bg-cover bg-center"
        style={{ 
          backgroundImage: `url(${hero})`,
          backgroundAttachment: "fixed"
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-[#2F3C7E]/70"></div>
        
        {/* Content */}
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            Our Services
          </h1>
          <p className="text-lg sm:text-xl text-[#E6B325]">
            Comprehensive Hospitality Solutions
          </p>
        </div>
      </section>

      {/* ===== INDUSTRIAL CATERING ===== */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8 md:gap-10 lg:gap-12">
            {/* Left Column - Image */}
            <div className="w-full md:w-1/2 mb-6 md:mb-0">
              <img 
                src={service1}
                alt="Industrial Catering"
                className="rounded-lg shadow-xl w-[90%] sm:w-[85%] md:w-[90%] lg:w-[85%] mx-auto"
              />
            </div>

            {/* Right Column - Content */}
            <div className="w-full md:w-1/2 lg:w-5/12 md:offset-1 text-center md:text-left px-2 sm:px-4">
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E] mb-4 sm:mb-6">
                Industrial Dining Solutions
              </h5>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed sm:leading-loose">
                Our commitment is to fulfill every client's unique requirements with services tailored 
                to their specific preferences and demands. With our team of skilled chefs and culinary 
                experts, we excel in preparing a diverse range of Indian and international cuisines 
                using only the finest, purest ingredients to ensure exceptional quality and taste.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CORPORATE STAY MANAGEMENT ===== */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-blue-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8">
            {/* Left Column - Content (Order changes on mobile) */}
            <div className="w-full md:w-1/2 order-2 md:order-1 text-center md:text-left px-2 sm:px-4 md:px-6 lg:pl-8">
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E] mb-4 sm:mb-6">
                Corporate Stay Management
              </h5>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed sm:leading-loose">
                Corporate Stay Management is an essential component of our hospitality services. 
                We maintain the highest standards of cleanliness and hygiene to ensure that 
                all guest house rooms, interiors, and exteriors are impeccably maintained and 
                beautifully presented for a comfortable and welcoming experience.
              </p>
            </div>

            {/* Right Column - Image (Order changes on mobile) */}
            <div className="w-full md:w-1/2 order-1 md:order-2 mb-6 md:mb-0">
              <img 
                src={service2} 
                alt="Corporate Stay Management"
                className="rounded-lg shadow-xl w-[90%] sm:w-[85%] md:w-[90%] lg:w-[85%] mx-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOUSEKEEPING & LAUNDRY ===== */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8 lg:gap-12">
            {/* Left Column - Image */}
            <div className="w-full md:w-1/2 mb-6 md:mb-0">
              <img 
                src={service3} 
                alt="Housekeeping & Laundry Services"
                className="rounded-lg shadow-xl w-[90%] sm:w-[85%] md:w-[90%] lg:w-[85%] mx-auto"
              />
            </div>

            {/* Right Column - Content */}
            <div className="w-full md:w-1/2 text-center md:text-left px-2 sm:px-4">
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E] mb-4 sm:mb-6">
                Professional Housekeeping & Laundry
              </h5>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed sm:leading-loose">
                The housekeeping department plays a vital role in every organization, ensuring 
                a clean and hygienic workspace for all. With our team of well-trained and 
                experienced staff, we efficiently manage daily cleaning tasks and maintain 
                the highest standards of cleanliness, providing you with a pristine and 
                healthy work environment at all times.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== MANPOWER SUPPLY ===== */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-blue-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8 lg:gap-12">
            {/* Left Column - Content (Order changes on mobile) */}
            <div className="w-full md:w-1/2 order-2 md:order-1 text-center md:text-left px-2 sm:px-4">
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E] mb-4 sm:mb-6">
                Staffing & Manpower Solutions
              </h5>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed sm:leading-loose">
                A dedicated team of professionals consistently delivers excellence in their work, 
                far surpassing the results of scattered individuals handling multiple tasks. 
                Access skilled manpower for every service your business requires and witness 
                immediate positive transformations in your operations.
              </p>
            </div>

            {/* Right Column - Image (Order changes on mobile) */}
            <div className="w-full md:w-1/2 order-1 md:order-2 mb-6 md:mb-0">
              <img 
                src={serviec4} 
                alt="Staffing & Manpower Solutions"
                className="rounded-lg shadow-xl w-[90%] sm:w-[85%] md:w-[90%] lg:w-[85%] mx-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== LANDSCAPE & GARDEN MANAGEMENT ===== */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8 lg:gap-12">
            {/* Left Column - Image */}
            <div className="w-full md:w-1/2 mb-6 md:mb-0">
              <img 
                src={serviec5} 
                alt="Landscape & Garden Management"
                className="rounded-lg shadow-xl w-[90%] sm:w-[85%] md:w-[90%] lg:w-[85%] mx-auto"
              />
            </div>

            {/* Right Column - Content */}
            <div className="w-full md:w-1/2 text-center md:text-left px-2 sm:px-4">
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E] mb-4 sm:mb-6">
                Landscape & Garden Management
              </h5>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed sm:leading-loose">
                Green spaces are vital to corporate environments, and professional landscape 
                management involves the complete care of gardens on business premises. Our 
                comprehensive services include designing, planting, and maintaining lush, 
                attractive outdoor areas through regular lawn upkeep, weed removal, proper 
                fertilization, pest control measures, and preservation of all garden features 
                to ensure year-round beauty and functionality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== COMMITMENT SECTION ===== */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-blue-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <div className="w-full max-w-5xl text-center px-4 sm:px-6">
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E] mb-4 sm:mb-6">
                Our Commitment
              </h5>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed sm:leading-loose">
                Through our extensive network, we deliver comprehensive catering solutions tailored 
                to meet our clients' specific requirements. We dedicate equal effort to research 
                and analysis as we do to flawless execution, constantly seeking innovative ways 
                to enhance workplace productivity through our methodologies. We consistently 
                exceed the expectations set by management and their teams, ensuring exceptional 
                value for every investment made in our services.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <CTASection />
    </Layout>
  );
};

export default ServicesPage;